'use client';

import Link from 'next/link';
import map from 'lodash/map';
import { Tag } from '@axa/design-system';

interface ITagsProps {
  tags: {
    id: string;
    text: string;
  }[];
}
export const Tags = ({ tags }: ITagsProps) => (
  <div className="hidden gap-1 lg:flex">
    {map(tags, (tag) => (
      <Link key={tag.id} href={`/central-de-ajuda/busca?search=${encodeURIComponent(tag.text)}`}>
        <Tag id={tag.id} variant="grey">
          {tag.text}
        </Tag>
      </Link>
    ))}
  </div>
);
